
import { applicationsList, chalaniList, progressReportList, relayList, updateApplicationService, storeRelayService, storeChalaniService, updateRelayByRouteService, updateApplicationByFieldsService, updateChalaniByObjectService, getApplicationService, updateRelayService, ConfigChalaniService, getChalaniService, ConfigProgressReportService, storeProgressReportService, getProgressReportService, updateProgressReportByObjectService } from '../../services/ApplicationServices';
import { ConfigApplicaitonTemplateService, ConfigService, ListUsersByRoleService } from '../../services/CustomerServices';

import * as ActionTypes from '../ActionTypes';
export const applicationListAction = (setRestrictedResponse, setRestrictedStatus, setBodyStatus,
     getDistrictName, setRows, 
    setApplications, setTableConnfig, customer_id = 0, 
    page, items, applicationTypeKey, searchKey = 'all', searchedVal = "",
    setCurrentUser, setAccessRestriction=false) => {
    
    return (dispatch) => {
        
        dispatch({ type: ActionTypes.LOADING });

        applicationsList(customer_id, page, items, applicationTypeKey, searchKey, searchedVal).then((res) => {
           

            if (res.hasOwnProperty('success') && res.success === true ) {
                setBodyStatus(true);
                let applications_data = res.data.data;
                applications_data.map((element) => (
                    element.company_id = (element.user.role_users_id==3)?"Individual":element.company.name_of_company,
                    element.created_by_id = element.user.first_name+' '+element.user.last_name,
                    element.client_id = element.client.first_name + ' ' + element.user.last_name,
                    element.internal_user_id = element.client.id,
                    element.application_template_id = element.type.name,
                    element.status = (element.relays.length == 0) ? "draft" : element.relays[parseInt(element.relays.length)-1].relay_status,
                    element.date = (element.relays.length == 0) ? element.application_date : element.relays[0].relay_date,
                    element.time = (element.relays.length == 0) ? element.application_time : element.relays[0].relay_time
                     
                
                ))
                setAccessRestriction(false)
                setRestrictedStatus(false)
                setRows(applications_data)
                setTableConnfig(res.data);
                setApplications(applications_data);
                setCurrentUser(res.user);
                dispatch({ type: ActionTypes.LOAD_APPLICATIONS_LIST_SUCCESS, res });
                 
            } else if (res.hasOwnProperty('success') && res.success === false) {
                if (res.success === false && Object.keys(res.message).includes('authorization_error')) {
                    setRestrictedResponse(res);
                    setRestrictedStatus(true);
                }
                dispatch({ type: ActionTypes.LOAD_APPLICATIONS_LIST_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
export const chalaniListAction = (setRestrictedResponse, setRestrictedStatus, setBodyStatus,
    getDistrictName, setRows,
    setApplications, setTableConnfig, customer_id = 0,
    page, items, applicationTypeKey, searchKey = 'all', searchedVal = "",
    setCurrentUser, setAccessRestriction = false, setPermission) => {

    return (dispatch) => {

        dispatch({ type: ActionTypes.LOADING });

        chalaniList(customer_id, page, items, applicationTypeKey, searchKey, searchedVal).then((res) => {


            if (res.hasOwnProperty('success') && res.success === true) {
                setBodyStatus(true);
                let chalani_data = res.data.data;
                chalani_data.map((element) => (
                    element.title = element.title,
                    element.user_id = element.user.first_name + ' ' + element.user.last_name,
                    element.application_id = element.applications.id,
                    element.issuer_id = element.issuer.first_name + ' ' + element.issuer.last_name,
                    element.name = element.applications.name,
                    element.application_template_id = element.applications.type.name,
                    element.status = (element.applications.relays.length == 0) ? "draft" : element.applications.relays[parseInt(element.applications.relays.length) - 1].relay_status
                    

                ))
                setAccessRestriction(false)
                setRestrictedStatus(false)
                setRows(chalani_data)
                setTableConnfig(res.data);
                setApplications(chalani_data);
                setCurrentUser(res.user);
                let access = [1, 6, 9, 10, 11].includes(res.user.role_users_id)? true : false;
                setPermission(access);
                dispatch({ type: ActionTypes.LOAD_APPLICATIONS_LIST_SUCCESS, res });

            } else if (res.hasOwnProperty('success') && res.success === false) {
                if (res.success === false && Object.keys(res.message).includes('authorization_error')) {
                    setRestrictedResponse(res);
                    setRestrictedStatus(true);
                }
                dispatch({ type: ActionTypes.LOAD_APPLICATIONS_LIST_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
export const progressReportListAction = (setRestrictedResponse, setRestrictedStatus, setBodyStatus,
    getDistrictName, setRows,
    setApplications, setTableConnfig, customer_id = 0,
    page, items, applicationTypeKey, searchKey = 'all', searchedVal = "",
    setCurrentUser, setAccessRestriction = false, setPermission) => {

    return (dispatch) => {

        dispatch({ type: ActionTypes.LOADING });

        progressReportList(customer_id, page, items, applicationTypeKey, searchKey, searchedVal).then((res) => {


            if (res.hasOwnProperty('success') && res.success === true) {
                setBodyStatus(true);
                let progress_data = res.data.data;
                progress_data.map((element) => (
                    element.title = element.title,
                    element.user_id = element.user.first_name + ' ' + element.user.last_name
                    

                ))
                setAccessRestriction(false)
                setRestrictedStatus(false)
                setRows(progress_data)
                setTableConnfig(res.data);
                setApplications(progress_data);
                setCurrentUser(res.user);
                let access = [1,3,4].includes(res.user.role_users_id) ? true : false;
                setPermission(access);
                dispatch({ type: ActionTypes.LOAD_APPLICATIONS_LIST_SUCCESS, res });

            } else if (res.hasOwnProperty('success') && res.success === false) {
                if (res.success === false && Object.keys(res.message).includes('authorization_error')) {
                    setRestrictedResponse(res);
                    setRestrictedStatus(true);
                }
                dispatch({ type: ActionTypes.LOAD_APPLICATIONS_LIST_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
export const updateApplicationAction = (credentials, setRestrictedResponse, setRestrictedStatus, getDistrictName,setState,fields) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });



        updateApplicationService(credentials).then((res) => {
            
            if (res.hasOwnProperty('success') && res.success === true) {
                //setRows(res.data);
                //setBodyStatus(true);
                let applications_data = res.data;
                applications_data.map((element) => (
                    element.status = (element.relays.length == 0) ? "draft" : element.relays[0].relay_status

                ))
                applications_data.map((element) => (
                    element.company_id = (element.user.role_users_id == 3) ? "Individual" : element.company.name_of_company,
                    element.created_by_id = element.user.first_name + ' ' + element.user.last_name,
                    element.client_id = element.client.first_name + ' ' + element.user.last_name,
                    element.application_template_id = element.type.name,
                    element.status = (element.relays.length == 0) ? "draft" : element.relays[0].relay_status

                ))



                dispatch({ type: ActionTypes.UPDATE_APPLICATION_SUCCESS, res });
                setState({
                    ...fields,
                    fieldStatus: true, // for message display
                    renderStatus: true // for refreshin the page
                });
               

            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
}
}

export const updateApplicationByFieldsAction = (credentials, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setApplicationResponse, history, setOpen, fields, setState, setBtnSubmitDisabled) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });
        updateApplicationByFieldsService(credentials).then((res) => {
           
            if (res.hasOwnProperty('success') && res.success === true) {
      
                let applications_data = res.data;
                applications_data.map((element) => (
                    element.status = (element.relays.length == 0) ? "draft" : element.relays[0].relay_status

                ))
                applications_data.map((element) => (
                    element.company_id = (element.user.role_users_id == 3) ? "Individual" : element.company.name_of_company,
                    element.created_by_id = element.user.first_name + ' ' + element.user.last_name,
                    element.client_id = element.client.first_name + ' ' + element.user.last_name,
                    element.application_template_id = element.type.name,
                    element.status = (element.relays.length == 0) ? "draft" : element.relays[0].relay_status

                ))

                setRows(applications_data)
                setApplications(applications_data);

                setRestrictedResponse(true);
                setRestrictedStatus(true);
                setBtnSubmitDisabled(false)

                setOpen(false);
                setState({
                    ...fields,
                    fieldStatus: true, // for message display
                    renderStatus: true // for refreshin the page
                });
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_SUCCESS, res });
                
            } else if (res.hasOwnProperty('success') && res.success === false) {
                setBtnSubmitDisabled(false)
                setApplicationResponse(res)
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_ERROR, res });
                
            }

        }, error => {
            setBtnSubmitDisabled(false)
            dispatch({ type: ActionTypes.CODE_ERROR, error })
            
        })
    }
}
export const updateChalaniByObject = (credentials, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setApplicationResponse, history, setOpen, fields, setState,setOpenCreate) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });
        updateChalaniByObjectService(credentials).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {
               

                setRestrictedResponse(true);
                setRestrictedStatus(true);
                setOpenCreate(false);
                setState({
                    ...fields,
                    fieldStatus: true, // for message display
                    renderStatus: true // for refreshin the page
                });
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_SUCCESS, res });


            } else if (res.hasOwnProperty('success') && res.success === false) {
                
                setApplicationResponse(res)
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
export const updateProgressReportByObject = (credentials, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setApplicationResponse, history, setOpen, fields, setState, setOpenCreate, setBtnSubmitDisabled, setEditable, setEditFlag, setDeletedFiles, setDropZoneValue) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });
        updateProgressReportByObjectService(credentials).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {


                setRestrictedResponse(true);
                setRestrictedStatus(true);
                setOpenCreate(false);
                setEditable(false);
                setState({
                    ...fields,
                    fieldStatus: true, // for message display
                    renderStatus: true // for refreshin the page
                });
                setBtnSubmitDisabled(false);
                setEditable(false);
                setEditFlag(false);
                setDeletedFiles([]);
                setDropZoneValue([]);
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_SUCCESS, res });
                

            } else if (res.hasOwnProperty('success') && res.success === false) {

                setApplicationResponse(res)
                setBtnSubmitDisabled(false);
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}

export const getApplicationAction = (credentials, setFlagger, flagger, setResult, formValuesLicensePOE, setFormValuesLicensePOE, defaultValuesLicensePOE, setConfigItem,geos,setOpen) => {
    return (dispatch) => {



        getApplicationService(credentials).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {
                //setRows(res.data);
                //setBodyStatus(true);
                let applications_data = res.data;
                applications_data.map((element) => (
                    element.status = (element.relays.length == 0) ? "draft" : element.relays[0].relay_status

                ))
                applications_data.map((element) => (
                    element.company_id = (element.user.role_users_id == 3) ? "Individual" : element.company.name_of_company,
                    element.created_by_id = element.user.first_name + ' ' + element.user.last_name,
                    element.client_id = element.client.first_name + ' ' + element.user.last_name,
                    element.application_template_id = element.type.name,
                    element.status = (element.relays.length == 0) ? "draft" : element.relays[0].relay_status

                ))

           
                setFlagger(!flagger);
                let temp_obj = {};
                let item = [];
                let fields = res.individualApplication;
                temp_obj = { ...temp_obj, ['name_of_the_project_of_electricity']: "thermal" }
                temp_obj = { ...temp_obj, ['type_of_electricity_to_be_surveyed_for_production']: "thermal" }

                fields.field_values.map((fieldElement) => {
                    item.push(fieldElement.field);
                  
                    if (fieldElement.field.type== 'file') {
                        
                      
                        temp_obj = { ...temp_obj, [fieldElement.field.slug]: JSON.parse(fieldElement.value).map(item_obj => parseInt(item_obj)) }
                        
                       
                    } 
                    else if (["state_1", "district_1", "municipality_1", "state_2", "district_2", "municipality_2", "state_3", "district_3", "municipality_3"].includes(fieldElement.field.slug)) {
                       
                        temp_obj = { ...temp_obj, [fieldElement.field.slug]: fieldElement.value.split(',').map(item_obj => parseInt(item_obj)) }
                       
                        
                    }else if (fieldElement.field.slug =="name_of_the_project_of_electricity"){
                        temp_obj = { ...temp_obj, ['name_of_the_project_of_electricity']: fieldElement.value }
                    } else if(fieldElement.field.slug == "type_of_electricity_to_be_surveyed_for_production"){
                        temp_obj = { ...temp_obj, ['type_of_electricity_to_be_surveyed_for_production']: fieldElement.value }
                    } else if (fieldElement.field.slug == "for_your_confirmation") {
                        temp_obj = { ...temp_obj, ['for_your_confirmation']: parseInt(fieldElement.value) }
                    }else{
                        temp_obj = { ...temp_obj, [fieldElement.field.slug]: fieldElement.value }
                    }
                   
                })
                /* start of for adding filtered option for district and municipalities */
                for(let i=1;i<=3;i++){
                if (temp_obj.hasOwnProperty("state_"+i)){
                    const districtFilter = [];
                    geos.forEach((geo) => {
                        if (temp_obj["state_" + i].includes(geo.id)) {

                            districtFilter.push(...geo.districts)

                        }
                    })
                    districtFilter.sort((a, b) => a.name.localeCompare(b.name))
                const municipalityFilter = districtFilter.filter((district) => temp_obj['district_'+i].includes(district.id)).flatMap(district => district.municipalities);

                    municipalityFilter.sort((a, b) => a.name.localeCompare(b.name))
                    temp_obj.districtFilter = districtFilter;
                    temp_obj.municipalityFilter = municipalityFilter;
                }
              }
                 /* end of for adding filtered option for district and municipalities */
                
                
              

                //dispatch({ type: ActionTypes.APPLICATION_TEMPLATE_FIELDS_SUCCESS, res });

                 setFormValuesLicensePOE(temp_obj);
                 setConfigItem(fields.type)
                 setResult(item);
                 setOpen(true);


            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
export const getChalaniAction = (credentials, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setFlagger, flagger, setResult, formValues, setFormValues, defaultValues, setFilesInfo,setOpenCreate) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });



        getChalaniService(credentials).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {
                //setRows(res.data);
                //setBodyStatus(true);
                let chalani_data = res.data.data;
                chalani_data.map((element) => (
                    element.title = element.title,
                    element.user_id = element.user.first_name + ' ' + element.user.last_name,
                    element.application_id = element.applications.id,
                    element.issuer_id = element.issuer.first_name + ' ' + element.issuer.last_name,
                    element.name = element.applications.name,
                    element.application_template_id = element.applications.type.name,
                    element.status = (element.applications.relays.length == 0) ? "draft" : element.applications.relays[parseInt(element.applications.relays.length) - 1].relay_status


                ))
             
                setFlagger(!flagger);


                //setFormValuesLicensePOE(defaultValuesLicensePOE);
                let temp_obj = {};
                let item = [];
                let chalani = res.individualApplication;
                temp_obj = { ...temp_obj, 
                    'title': chalani.title,
                    'issuer_id': chalani.issuer_id,
                    'chalani_number': chalani.chalani_number,
                    'letter_date':chalani.letter_date,
                    'user_id': chalani.user_id,
                    'application_id': chalani.application_id,
                    'file': chalani.file==null?[]:chalani.file,
                    'file_info': chalani.file_info != null ? chalani.file_info : []
                    }
                setFilesInfo(chalani.file_info);

                setFormValues(temp_obj);


                dispatch({ type: ActionTypes.APPLICATION_TEMPLATE_FIELDS_SUCCESS, res });

                setOpenCreate(true);



            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
export const getProgressReportAction = (credentials, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setFlagger, flagger, setResult, formValues, setFormValues, defaultValues, setFilesInfo, setOpenCreate) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });



        getProgressReportService(credentials).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {
                //setRows(res.data);
                //setBodyStatus(true);
                let progress_report_data = res.data.data;
                progress_report_data.map((element) => (
                    element.title = element.title,
                    element.user_id = element.user.first_name + ' ' + element.user.last_name
                    

                ))


                setFlagger(!flagger);


                //setFormValuesLicensePOE(defaultValuesLicensePOE);
                let temp_obj = {};
                let item = [];
                let progress_report = res.individualApplication;
                temp_obj = {
                    ...temp_obj,
                    'title': progress_report.title,
                    'description': progress_report.description,
                    'user_id': progress_report.user_id,
                    
                    'file': progress_report.file == null ? [] : progress_report.file,
                    'file_info': progress_report.file_info != null ? progress_report.file_info : []
                }
                setFilesInfo(progress_report.file_info);

                setFormValues(temp_obj);


                dispatch({ type: ActionTypes.APPLICATION_TEMPLATE_FIELDS_SUCCESS, res });

                setOpenCreate(true);



            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}

export const ConfigApplicaitonTemplate = (setApplicationTypes) => {
    return ConfigApplicaitonTemplateService().then((res) => {
        if (res.hasOwnProperty('success') && res.success === true) {
            setApplicationTypes(res.data);
            return res;
        } else if (res.hasOwnProperty('success') && res.success === false) {
            return res;
        }

    });


}
export const ConfigChalani = (setApplicationTypes) => {
    return ConfigChalaniService().then((res) => {
        if (res.hasOwnProperty('success') && res.success === true) {
            setApplicationTypes(res.data);
            return res;
        } else if (res.hasOwnProperty('success') && res.success === false) {
            return res;
        }

    });


}
export const ConfigProgressReport = (setApplicationTypes) => {
    return ConfigProgressReportService().then((res) => {
        if (res.hasOwnProperty('success') && res.success === true) {
            setApplicationTypes(res.data);
            return res;
        } else if (res.hasOwnProperty('success') && res.success === false) {
            return res;
        }

    });


}

export const Config = () => {
    return ConfigService().then((res) => {
        if (res.hasOwnProperty('success') && res.success === true) {
            return res;
        } else if (res.hasOwnProperty('success') && res.success === false) {

            return res;
        }

    });


}
export const ListUsersByRole = (role, temp_obj, fieldsAssignment, setFieldsAssignment) => {
   
    return ListUsersByRoleService(role, temp_obj).then((res) => {
      

            if (res.hasOwnProperty('success') && res.success === true) {
                let users = res.data;
                let receiver_id = (role == 3 || role == 4) ? temp_obj.creator : users[0].id;
                setFieldsAssignment({ ...temp_obj, role_user: role, users_by_role: users})
                return res;
            } else if (res.hasOwnProperty('success') && res.success === false) {

                return res;
            }

    });



}
export const relayListAction = (setRestrictedResponse, setRestrictedStatus, getDistrictName,setBodyStatus,setRows, setApplications, setTableConnfig, customer_id = 0, page, items, applicationTypeKey, searchKey = 'all', searchedVal = "") => {

    return (dispatch) => {

        dispatch({ type: ActionTypes.LOADING });

        relayList(customer_id, page, items, applicationTypeKey, searchKey, searchedVal).then((res) => {

           
            if (res.hasOwnProperty('success') && res.success === true) {
                setBodyStatus(true);
                let applications_data = res.data.data;
                       

                applications_data.map((element) => (
                    element.receiver_id = (element.receiver != null && element.receiver_id != null) ? element.receiver?.first_name + ' ' + ((element.receiver.middle_name != null) ? (element.receiver.middle_name + " ") : "") +element.receiver?.last_name:"",
                    element.sender_id = element.sender.first_name + ' ' + ((element.sender.middle_name != null) ? (element.sender.middle_name + " ") : "")+ element.sender.last_name,
                    element.created_by_id = element.creator.first_name + ' ' + ((element.creator.middle_name != null) ? (element.creator.middle_name + " ") : "") + element.creator.last_name,
                    element.message = element.message!==null?element.message:"Please check it.",
                    element.comment = element.comment!==null?element.comment:"I have checked it.",
                    element.relay_time = element.relay_time,
                    element.relay_date = element.relay_date,
                    element.relay_status = element.relay_status,
                    element.application_id = element.applications.name,
                    element.receive_note = element.reciever!==null?element.receive_note:"Yes, I have recieved it." 
                ))
                setRows(applications_data)
                setTableConnfig(res.data);
                setApplications(applications_data);
                dispatch({ type: ActionTypes.LOAD_APPLICATIONS_LIST_SUCCESS, res });

            } else if (res.hasOwnProperty('success') && res.success === false) {
                if (res.success === false && Object.keys(res.message).includes('authorization_error')) {
                    setRestrictedResponse(res);
                    setRestrictedStatus(true);
                }
                dispatch({ type: ActionTypes.LOAD_APPLICATIONS_LIST_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
export const updateRelayAction = (credentials, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });
       


        updateRelayService(credentials).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {
                //setRows(res.data);
                //setBodyStatus(true);
                let applications_data = res.data.data;
                // applications_data.map((element) => (
                //     element.status = (element.relays.length == 0) ? "draft" : element.relays[0].relay_status

                // ))
                // applications_data.map((element) => (
                //     element.company_id = (element.user.role_users_id==3)?"Individual":element.company.name_of_company,
                //     element.created_by_id = element.user.first_name + ' ' + element.user.last_name,
                //     element.client_id = element.client.first_name + ' ' + element.user.last_name,
                //     element.application_template_id = element.type.name,
                //     element.status = (element.relays.length == 0) ? "draft" : element.relays[0].relay_status,
                //      element.application_id = element.applications.name

                // ))

                setRows(applications_data)
                setApplications(applications_data);
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_SUCCESS, res });


            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.UPDATE_APPLICATION_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}

export const storeRelayAction = (credentials, setRows, setApplications, fields, setState, setApplicationResponse, setBtnStatusDisabled) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });



        storeRelayService(credentials).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {
               
              

                
                setBtnStatusDisabled(false);
                setState({...fields, renderStatus:true})
              
                dispatch({ type: ActionTypes.STORE_RELAY_SUCCESS, res });


            } else if (res.hasOwnProperty('success') && res.success === false) {
                setApplicationResponse(res)
                dispatch({ type: ActionTypes.STORE_RELAY_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}

export const updateRelayByRouteAction = (credentials, fieldsAssignment, setFieldsAssignment, fields, setState, setApplicationResponse,setBtnSubmitDisabled) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });



        updateRelayByRouteService(credentials).then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {
                setFieldsAssignment({ ...fieldsAssignment, fieldStatus: true })
                setState({ ...fields, renderStatus:true});
                //dispatch({ type: ActionTypes.STORE_RELAY_SUCCESS, res });
                setBtnSubmitDisabled(false);
            } else if (res.hasOwnProperty('success') && res.success === false) {
                setApplicationResponse(res)
                dispatch({ type: ActionTypes.STORE_RELAY_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}

export const storeChalaniAction = (credentials, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setApplicationResponse, history, setOpen, fields, setState, setOpenCreate) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });
        storeChalaniService(credentials).then((res) => {
            if (res.hasOwnProperty('success') && res.success === true) {
                setRestrictedResponse(true);
                setRestrictedStatus(true);
                setOpenCreate(false);
                setState({
                    ...fields,
                    fieldStatus: true, // for message display
                    renderStatus: true // for refreshin the page
                });
                dispatch({ type: ActionTypes.CUSTOMER_GENERAL_INFO_STORE_SUCCESS, res });
 
            } else if (res.hasOwnProperty('success') && res.success === false) {
                setApplicationResponse(res)
                dispatch({ type: ActionTypes.CUSTOMER_GENERAL_INFO_STORE_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
export const storeProgressReportAction = (credentials, setRestrictedResponse, setRestrictedStatus, getDistrictName, setRows, setApplications, setApplicationResponse, history, setOpen, fields, setState, setOpenCreate, setBtnSubmitDisabled) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.LOADING });
        storeProgressReportService(credentials).then((res) => {
            if (res.hasOwnProperty('success') && res.success === true) {
                setRestrictedResponse(true);
                setRestrictedStatus(true);
                setOpenCreate(false);
                setState({
                    ...fields,
                    fieldStatus: true, // for message display
                    renderStatus: true // for refreshin the page
                });
                setBtnSubmitDisabled(false)
                dispatch({ type: ActionTypes.CUSTOMER_GENERAL_INFO_STORE_SUCCESS, res });
  
            } else if (res.hasOwnProperty('success') && res.success === false) {
                setApplicationResponse(res)
                setBtnSubmitDisabled(false)
                dispatch({ type: ActionTypes.CUSTOMER_GENERAL_INFO_STORE_ERROR, res });
            }

        }, error => {
            setBtnSubmitDisabled(false)
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}
